import { render, staticRenderFns } from "./AgentProfileAppraisal.vue?vue&type=template&id=85873760&scoped=true&"
import script from "./AgentProfileAppraisal.vue?vue&type=script&lang=ts&"
export * from "./AgentProfileAppraisal.vue?vue&type=script&lang=ts&"
import style0 from "./AgentProfileAppraisal.vue?vue&type=style&index=0&id=85873760&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85873760",
  null
  
)

export default component.exports